






import { defineComponent, ref, useFetch } from '@nuxtjs/composition-api';

import { useUrlResolver } from '~/composables';
import CATEGORY from '~/modules/catalog/pages/category.vue';
import PRODUCT from '~/modules/catalog/pages/product.vue';
import SEARCH from '~/modules/catalog/pages/search.vue';
import CMS_PAGE from '~/pages/Cms.vue';
import { usePageStore } from '~/stores/page';

export default defineComponent({
  name: 'PageResolver',
  components: {
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
    SEARCH,
  },
  middleware: ['url-resolver'],
  setup() {
    console.log('--------- Page.vue Start --------');
    const type = ref();
    const { routeData } = usePageStore();
    const pageStore = usePageStore();

    const { search } = useUrlResolver();
    if (routeData) {
      type.value = routeData?.type;
    }
    useFetch(async () => {
      if (!routeData) {
        const urlResolverResult = await search();
        console.log('*** urlResolverResult', urlResolverResult);
        if (urlResolverResult) {
          type.value = urlResolverResult?.type;
          pageStore.routeData = urlResolverResult;
        }
      }
    });
    return {
      type,
    };
  },
});
